import './AllComponentsContainer.css';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
let AllComponentsContainer =(props)=>{
  

 

//    ******************************upload photo*******************************
let clickHandler =(event)=>{
    event.preventDefault(); 
} 

let Checkboxclickhandler =(event)=>{
    if(event.target.checked){
        document.querySelector('.lable').classList.toggle('active');
        document.querySelector('.photo_cont').classList.toggle("active");

    }else{
        document.querySelector('.lable').classList.remove('active');
        document.querySelector('.photo_cont').classList.remove("active");

    }
    
}
let [carrierobj, setcarrierobj]=useState('');

let carobjdata=(e)=>{
    if(e.target.checked == true){
        setcarrierobj("To seek a good & responsible job in professionally managed organization where in my conceptual and functional skills are effectively utilized in a way that contributes to the organization growth coupled with personal growth within the organization");
    }
    
}


let onchangeimagehandler = (event) => {
    if(event.target.files && event.target.files[0]){
        let Finalimage = (URL.createObjectURL(event.target.files[0]));
        props.getimage(Finalimage);
    }
    
}
// 8888888888888888888888888    8personal d8888888888888888888888888888888
 let checkboxclickhandler =(event2)=>{
        if(event2.target.checked){
            document.querySelector('.all_input_cont').classList.toggle('active4');
            document.querySelector('.perinfo_fieldset').classList.toggle("active3");
        }else{
            document.querySelector('.all_input_cont').classList.remove('active4');
            document.querySelector('.perinfo_fieldset').classList.remove("active3");
        }
        
    }
      

    
        // ********************contact data**************

           let checkboxclickhandlercontact =(event2)=>{
                if(event2.target.checked){
                    document.querySelector('.Contact_fieldset').classList.toggle('active7');
                    document.querySelector('.contact_inputs_cont').classList.toggle('active8');
        
                    
                }else{
                    document.querySelector('.Contact_fieldset').classList.remove('active7');
                    document.querySelector('.contact_inputs_cont').classList.remove('active8');
        
                }
                
            }
        
// ***********************ADDRESS DATA**************************
    let checkboxclickhandleraddress =(event2)=>{
        if(event2.target.checked){
            document.querySelector('.addr_inputs_cont').classList.toggle('active9');
            document.querySelector('.addr_fieldset').classList.toggle("active10");
        }else{
            document.querySelector('.addr_inputs_cont').classList.remove('active9');
            document.querySelector('.addr_fieldset').classList.remove("active10");
        }
        
    }

   



let [inputs, setunputs]=useState({});
let inputchangehandler=(e)=>{
    let name = e.target.name;
    let value = e.target.value;
    setunputs(values =>({...values, [name]: value}));
}


let [dataforcheckdet, setdataforcheckdet] =useState('');
let funalnext=()=>{
    
    let DATA = {
        Name : inputs.applicantname,
        fname : inputs.fathername,
        Mname : inputs.mothername,
        dob : inputs.date,
        Nationality : inputs.nationality,
        Religion : inputs.religion,
        Marital_Status : inputs.maritalstatus,
        Hobbies : inputs.hobbies,
        Languages : inputs.language,
        hnum : inputs.Hnum,
        Village : inputs.Vill,
        Thana : inputs.police,
        Post_Office : inputs.post,     
        District : inputs.city,
        State : inputs.state,
        Pin_Code : inputs.pincode,
        mobnum : inputs.MobileNum,
        Email_ID :  inputs.Email,
        Alternate : inputs.Altnum
    }
    if(DATA.Name==undefined){
        props.Successandrerrorfun("","Enter Name")
        return;
    }else if(DATA.fname==undefined){
        props.Successandrerrorfun("","Father name required");
        return
    }else if(DATA.Mname==undefined){
        props.Successandrerrorfun("","Mother name is required");
        return;
    }else if(DATA.dob==undefined){
        props.Successandrerrorfun("","Date of birth required");
        return;
    }else if(DATA.Village==undefined){
        props.Successandrerrorfun("",'village required');
        return
    }else if(DATA.Post_Office==undefined){
        props.Successandrerrorfun("","Post required");
        return;
    }else if(DATA.District==undefined){
        props.Successandrerrorfun("","District required");
        return;
    }else if(DATA.State==undefined){
        props.Successandrerrorfun("","state required");
        return;
    }else if(DATA.Pin_Code==undefined){
        props.Successandrerrorfun("","Pin code required");
        return;
    }
    setdataforcheckdet(DATA);
    document.querySelector(".hidecheckdetailscomp").style.display = "block";
    document.querySelector(".allcomponents").style.display = "none";  
    CheckEmptyValues(); 

    
}

let Finalsubmitfun=()=>{
    props.getdemocontdatall(inputs);
    props.carrierdata(carrierobj);
    
}












// academic section++++++++++++++++++++++++++++++++++++++++++++++++++++++++
let checkboxclickhandleracademic =(event2)=>{
        if(event2.target.checked){
            // document.querySelector('.academic_table_cont').classList.toggle('active11');
            document.querySelector('.academic_fieldset_cont').classList.toggle("active12");
        }else{
            // document.querySelector('.academic_table_cont').classList.remove('active11');
            document.querySelector('.academic_fieldset_cont').classList.remove("active12");
            
        }
        
    }


    let [GotStream, setGotStream] = useState('');
    let [GotBoardUnivercity, setGotBoardUnivercity] = useState('');
    let [GotAcaPassingYear, setAcaGotPassingYear] = useState('');
    let [GotAcademicPercentage, setAcademicGotPercentage] = useState('');


    let GetStream =(event) => {
        setGotStream(event.target.value);
    }

    let GetBoardUnivercity =(event) => {
        setGotBoardUnivercity(event.target.value);
    }
    let GetPassingYear = (event) => {
        setAcaGotPassingYear(event.target.value);
    }
    let GetAcademicPercentage = (event) => {
        setAcademicGotPercentage(event.target.value);
    }

let [Academicddata ,setAcademicddata]=useState(['']);
let funtogetacademicdata=(acadata)=>{
    let acadarray=[acadata, ...Academicddata];
    setAcademicddata(acadarray);
}
    let AcademicClickHandler = (event) => {
        event.preventDefault();

        let AcademicDataCollection = {
            ExamName: GotStream,
            BoardName: GotBoardUnivercity,
            PassingYear: GotAcaPassingYear,
            PercentAge: GotAcademicPercentage
        };
        // console.log(AcademicDataCollection);
        props.GetAcademicData(AcademicDataCollection);
        funtogetacademicdata(AcademicDataCollection);
        
        setGotStream('');
        setGotBoardUnivercity('');
        setAcaGotPassingYear('');
        setAcademicGotPercentage('');
    }


    let checkboxclickhandlercom =(event2)=>{
            if(event2.target.checked){
                // document.querySelector('.comp_table').classList.toggle('active13');
                document.querySelector('.comp_fieldset_cont').classList.toggle("active14");
            }else{
                // document.querySelector('.comp_table').classList.remove('active13');
                document.querySelector('.comp_fieldset_cont').classList.remove("active14");
            }
            
        }
    
        let [GotCourseName , setGotCourseName] = useState('');
        let [GotFromWhere, setGotFromWhere] = useState('');
        let [GotPassingYear, setPassingYear] = useState('');
        let [GotPercentage, setGotPercentage] = useState('');
    
    
        let   GetCourseName = (event) =>{
            setGotCourseName(event.target.value);
        }
        let GetFormWhere = (event) => {
            setGotFromWhere(event.target.value);
        }
        let GetPssingYear = (event) => {
            setPassingYear(event.target.value);
        }
        let GetPercentage = (event) => {
            setGotPercentage(event.target.value);
        }
    
        let [Comddata, setComddata]=useState(['']);
        let funtogetcomdata=(comdd)=>{
            let comdataarray=[comdd, ...Comddata];
            setComddata(comdataarray);
        }
    
    
    
        let ComputerClickHandler = (event) => {
        event.preventDefault();
    
            let ComputerDataCollection = {
                CourseName: GotCourseName,
                Frompass: GotFromWhere,
                Compassingy: GotPassingYear,
                compercent: GotPercentage
            };
            props.GetComputerData(ComputerDataCollection);
            funtogetcomdata(ComputerDataCollection);
    
    
            setPassingYear('');
            setGotFromWhere('');
            setGotCourseName('');
            setGotPercentage('');
    
    
            }


    // Technical section-------------------------------------------------------

    let checkboxclickhandlertech =(event2)=>{
            if(event2.target.checked){
                // document.querySelector('.tech_table_cont').classList.toggle('active15');
                document.querySelector('.tech_fieldset_cont').classList.toggle("active16");
            }else{
                // document.querySelector('.tech_table_cont').classList.remove('active15');
                document.querySelector('.tech_fieldset_cont').classList.remove("active16");
            }
            
        }
        let [GotCourseNametech, setGotCourseNametech] = useState('');
        let [GotTradeName , setGotTradeName] = useState('');
        let [GotTechPassingYear, setGotTradePassingYear] = useState('');
        let [GotTechPercentagetech, setGotPercentagetech] = useState('');
        let [GotTechFromWhere, setGotTechFromWhere] = useState('');
    
        let GetTecCourseName = (event) =>{
            setGotCourseNametech(event.target.value);
        }
        let GetTradeName =(event)=>{
            setGotTradeName(event.target.value);
        }
        let GetTechPassingYear = (event) => {
            setGotTradePassingYear(event.target.value);
        }
        
        let GetTechPercentage=(event)=>{
            setGotPercentagetech(event.target.value);
        }
        let GetTechFromWhere =(event) => {
            setGotTechFromWhere(event.target.value);
    
        }
    


        let [Techdata, settechdata]=useState(['']);
        let funtogettechdata=(techdata)=>{
            let techaarray=[techdata, ...Techdata];
            settechdata(techaarray);
        }
        let TechClickHandler = (event) => {
            event.preventDefault();
    
            let TechDataCollection = {
                TechCourseName:GotCourseNametech,
                TechTradeName: GotTradeName,
                TechPassingYear:GotTechPassingYear,
                TechPercentage: GotTechPercentagetech,
                Techfromwhere: GotTechFromWhere
            };
            funtogettechdata(TechDataCollection);
            props.GetTechnicalData(TechDataCollection);
            
    
    
    
    
            setGotCourseNametech('');
            setGotTradeName('');
            setGotTradePassingYear('');
            setGotPercentagetech('');
            setGotTechFromWhere('');
    
    
        }
    

// work section-------------------------------------------------------------

let checkboxclickhandlerwork=(e)=>{
        if(e.target.checked){
            // document.querySelector('.exp_form_cont').classList.toggle('activeexp');
            document.querySelector('.main_fieldset_exp').classList.toggle("activeFiedlset");
        }else{
            // document.querySelector('.exp_form_cont').classList.remove('active9');
            document.querySelector('.main_fieldset_exp').classList.remove("activeFiedlset");
        }
    }

    let [GotworkedYearwork, setgotworkedyearwork] = useState('');
    let [GotCompanyName, setgotCompanyName] = useState('');
    let [GotCompanyAddress, setgotCompanyAddress] = useState('');
    let [GotCompanyDatetodate, setgotCompanyDatetidate] = useState('');


    let EnteredworkedExperience=(e)=> {
        setgotworkedyearwork(e.target.value);
    }
    let EnteredCompanyName=(e)=>{
        setgotCompanyName(e.target.value);
    }
    let EnteredCompanyAddress=(e)=>{ 
        setgotCompanyAddress(e.target.value);
    }
    let EnteredCompanyDateToDate=(e)=>{
        setgotCompanyDatetidate(e.target.value);
    }



    let [Workexp, setworkdata]=useState(['']);
    let funtoworkdata=(workdata)=>{
        let workarray=[workdata, ...Workexp];
        setworkdata(workarray);
    }
    let ExpFormSubmitHandler=(e)=>{
        e.preventDefault();

        let WorkExperienceData ={
            ExperianceYear : GotworkedYearwork,
            CompanyName : GotCompanyName,
            CompanyAddress : GotCompanyAddress,
            FromDateToDate : GotCompanyDatetodate,
            Year : " Year Worded As ",
            At : " At ",
            From : " From "
        };
        funtoworkdata(WorkExperienceData);
        props.GetExpData(WorkExperienceData);
        setgotworkedyearwork('');
        setgotCompanyName('');
        setgotCompanyAddress('');
        setgotCompanyDatetidate('');
    }

    let CheckEmptyValues = () =>{  
        
        let academicchildren = document.querySelector(".academind"); 
        let technicalchildre = document.querySelector(".techincaltablecont");
        let computerchildren = document.querySelector(".computertablecont");
        let ExperienceChildren = document.querySelector('.Exp_cont_in_checkdetails');




    if(Academicddata != ""){   
        academicchildren.style.display = "block";  

    }else{
        academicchildren.style.display = "none"; 
        // props.AcademicData.splice(props.AcademicData.length - 1, 1);
    }
    if(Techdata == ''){
        technicalchildre.style.display = "none";
    }else{ 
        // props.TechDataexp.splice(props.TechDataexp.length - 1, 1);
    }
    if(Comddata == ''){
        computerchildren.style.display = "none";
    }else{
        // props.ComputerData.splice(props.ComputerData.length - 1, 1);
    }
    if(Workexp == ""){
        ExperienceChildren.style.display = "none";
    }else{
        // props.ExperienceData.splice(props.ExperienceData.length - 1, 1) 
    }
    

  
}


let Clickhandler =()=> {
    let allcheckingcheckboxes = document.querySelectorAll(".allinpts_checkbox");
    for(let x of allcheckingcheckboxes){
        if(x.checked){
            if(x.id === "TechData"){
                document.querySelector("#Techid").style.display = "block";
            }else if(x.id === "AcademicQlf"){
                document.querySelector("#Academiccont").style.display = "block";
            }else if(x.id === "ComputerQlf"){ 
                document.querySelector("#Computerid").style.display = "block";
            }else if(x.id === "Experience"){
                document.querySelector("#ExperienceId").style.display = "block";

            }
        }
        document.querySelector(".allcomponentcaption").style.display = "block";
        document.querySelector(".allcomponents").style.display = "block";
        document.querySelector(".ChooseResNeed_cont").style.display = "none";
    }
     
} 

    return(
        <div className='allcomponents_cont'>
            <div className='ChooseResNeed_cont'>
                <div className='allinputs_field'>
                    <div>
                        <h3>Choose Your Qualification And Experience</h3>
                    </div>
                    <div className='NotSameForAll samestyling'>
                        <div className='inputs_conts'>
                            <label htmlFor='AcademicQlf'>Academic Qualification</label>
                            <input  id='AcademicQlf' type='checkbox' className='allinpts_checkbox'/>
                        </div>
                        <div className='inputs_conts'>
                            <label htmlFor='ComputerQlf'>Computer Qualification</label>
                            <input id='ComputerQlf'  type='checkbox' className='allinpts_checkbox'/>
                        </div>
                        <div className='inputs_conts'>
                            <label htmlFor='TechData'>Technical Qualification</label>
                            <input id='TechData'  type='checkbox' className='allinpts_checkbox'/>
                        </div>
                        <div className='inputs_conts'>
                            <label htmlFor='Experience'>Show Your Experience</label>
                            <input id='Experience'  type='checkbox' className='allinpts_checkbox'/> 
                        </div>
                    </div>
                </div>
                <div className='Submitbtn_cont'>
                    <button onClick={Clickhandler} className='btn'>Submit</button>  
                </div>
                <div>
                    <p>Fill Form Carefully ! Because You cannot edit if wrong</p>
                </div>
            </div>   
 
        
            <div className='allcomponents'> 
                <h4 className='allcomponentcaption'>Fill Form Very Carefully</h4>
                <form onSubmit={clickHandler}>
                    <fieldset className='photo_cont'>
                        <input type='checkbox' className='checkbox' onClick={Checkboxclickhandler}/>
                        <legend>Photo Upload</legend>
                        <label className='lable' htmlFor='uploadd'>Upload Photo</label>
                        <input id='uploadd' onChange={onchangeimagehandler}  type='file'/><br></br>
                        <label className='carrierlable' htmlFor='carobj'>Carrier Objective</label>
                        <input type='checkbox' id='carobj'  onChange={carobjdata}/>

                        
                    </fieldset>
                </form>

                <form className='personal_info_cont'>
            
                    <fieldset className='perinfo_fieldset'>
                        <input type='checkbox' className='checkboxx' onClick={checkboxclickhandler}/>
                        <legend className='perinfo_legend'>Personal Information</legend>  
                        <div className='all_input_cont'>
                            <input className='perinfo_inputs' name='applicantname' value={inputs.applicantname} onChange={inputchangehandler} type='text' placeholder='Enter Name'/>
                            <input className='perinfo_inputs' name='fathername' value={inputs.fathername} onChange={inputchangehandler} type='text' placeholder="Father's Name"/>
                            <input className='perinfo_inputs' name='mothername'  value={inputs.mothername} onChange={inputchangehandler} type='text' placeholder="Mother's Name"/>
                            <input className='perinfo_inputs' name='nationality' value={inputs.nationality} onChange={inputchangehandler} type='text' placeholder="Nationality"/>
                            <input  className='perinfo_inputs' name='hobbies' value={inputs.hobbies} onChange={inputchangehandler}type='text' placeholder="Hobbyes" />
                            <input className='perinfo_inputs' name='language' value={inputs.language} onChange={inputchangehandler} type='text' placeholder="Languages"/>
                            <input className='perinfo_inputs' name='maritalstatus'  value={inputs.maritalstatus} onChange={inputchangehandler} type='text' placeholder="Marital Status"/>
                            <input  className='perinfo_inputs' name='religion' value={inputs.religion} onChange={inputchangehandler} type='text' placeholder="Religion" />
                            <input className='perinfo_inputs' name='date' value={inputs.date} onChange={inputchangehandler} type='date' />
                        </div>
                    </fieldset>
                </form>

{/* ***********************contact data******************************* */}


        <form>
            <fieldset className='Contact_fieldset'>
                <legend>Contact Details</legend>
                <input type='checkbox' className='checkboxxx' onClick={checkboxclickhandlercontact}/>
                <div className='contact_inputs_cont'>
                    <input type="number" onChange={inputchangehandler} name='MobileNum' value={inputs.MobileNum} placeholder="Enter Mobile Number" className="add_contact_det"/>
                    <input type="email" onChange={inputchangehandler} name='Email' value={inputs.Email} placeholder="Enter Email Id" className="add_contact_det"/>
                    <input type="altnumber" onChange={inputchangehandler} name='Altnum' value={inputs.Altnum} placeholder="Alternate Mobile Number" className="add_contact_det"/>
                </div>
                
            </fieldset>
        </form>

{/* **************************************address data********************* */}

        <form>
             <fieldset className='addr_fieldset'>
                <legend>Address Details</legend>
                <input type='checkbox' className='checkboxxx' onClick={checkboxclickhandleraddress}/>
                <div className='addr_inputs_cont'>
                    <input type="text" value={inputs.Hnum} name='Hnum'  onChange={inputchangehandler} placeholder="House Number" className="addr_inputs"/>
                    <input type="text" value={inputs.Vill} name='Vill'  onChange={inputchangehandler} placeholder="Village" className="addr_inputs"/>
                    <input type="text"  value={inputs.post} name='post' onChange={inputchangehandler} placeholder="Post Office" className="addr_inputs"/>
                    <input type="text"  value={inputs.police} name='police' onChange={inputchangehandler} placeholder="Police Station" className="addr_inputs"/>
                    <input type="text" value={inputs.city} name='city'  onChange={inputchangehandler} placeholder="City" className="addr_inputs"/>
                    <input type="text"  value={inputs.state} name='state' onChange={inputchangehandler} placeholder="State" className="addr_inputs"/>
                    <input type="number"  value={inputs.pincode} name='pincode' onChange={inputchangehandler} placeholder="Enter Pin Code" className="addr_inputs"/>
                </div>
                
            </fieldset>
        </form>

        {/* academic data---------------------------------------------- */}


        <form id='Academiccont' onSubmit={AcademicClickHandler}>
            <fieldset  className='academic_fieldset_cont'>
                <legend>Academic Qualification</legend>
                <input type='checkbox' className='checkboxxx' onClick={checkboxclickhandleracademic}/>
                <div  className='academic_table_cont'>
                    <table>
                        <thead>
                            <tr>
                                <td>Enter Stream</td>
                                <td><input type="text" value={GotStream} onChange={GetStream} placeholder="Stream" className="input_stream1 acadmic_inputs"/></td>
                               
                            </tr>
                            <tr>
                            <td>Board/ University</td>
                            <td><input type="text" value={GotBoardUnivercity} placeholder='Board/Univercity'  onChange={GetBoardUnivercity}  className="input_board1 acadmic_inputs"/></td>
                               
                            </tr>
                            <tr>
                            <td>Passing Year</td>
                            <td><input type="text" value={GotAcaPassingYear}  onChange={GetPassingYear} placeholder='Passing Year'  className="input_year1 acadmic_inputs"/></td>
                            
                            </tr>
                            <tr>
                            <td>%AGE</td>
                            <td><input type="text" placeholder='%Age' value={GotAcademicPercentage}  onChange={GetAcademicPercentage}  className="input_percentag1 acadmic_inputs"/></td>
                            </tr>
                        </thead>
                    </table>
                        <div className='submit_cont'>
                            <button className='btnbtn' onClick ={AcademicClickHandler}>Submit</button>
                        </div>
                </div>
              
                
            </fieldset>
        </form>


        {/* computer section+++++++++++++++++++++++++++++++++++++++++++++++++ */}
        <form id='Computerid' onSubmit={ComputerClickHandler}>
             <fieldset className='comp_fieldset_cont'>
                <legend>Computer Qulification</legend>
                <input type='checkbox' className='checkboxxx' onClick={checkboxclickhandlercom}/>
                <div className='comp_table'>
                    <table>
                        <thead>
                            <tr>
                                <td>Course Name</td>
                                <td><input type="text" value={GotCourseName} onChange={GetCourseName} placeholder="Course Name" className="comp_inputs"/></td>
                            </tr>
                            <tr>
                                <td>From Where</td>
                                <td><input placeholder='From Where' type="text" value={GotFromWhere}  onChange={GetFormWhere}  className="comp_inputs"/></td>

                               
                            </tr>
                            <tr>
                                <td>Passing Year</td>
                                <td><input placeholder='Passing Year' type="text" value={GotPassingYear}  onChange={GetPssingYear}  className="comp_inputs"/></td>
                            </tr>
                            <tr>
                                <td>%AGE</td>
                                <td><input placeholder='%Age' type="text" value={GotPercentage}  onChange={GetPercentage}  className="comp_inputs"/></td>
                            </tr>

                        </thead>
                    </table>
                    <div className='submit_cont'>
                        <input className='comp_inputs' type='submit' value='submit'/>
                    </div>
                </div>
                
            </fieldset>
        </form>


        <form id='Techid' onSubmit={TechClickHandler}>
            <fieldset className='tech_fieldset_cont'> 
                <legend>Technical Qualification</legend>
                <input type='checkbox' className='checkboxxx' onClick={checkboxclickhandlertech}/>
                <div className='tech_table_cont'>
                    <table>
                        <thead>
                            <tr>
                                <td>CourseName</td>
                                <td><input type="text" value={GotCourseNametech} onChange={GetTecCourseName} placeholder="Course Name" className="tech_stream_input"/></td>
                               
                            </tr>
                            <tr>
                                <td>TradeName</td>
                                <td><input placeholder='Trade Name' type="text"value={GotTradeName} onChange={GetTradeName} className="tech_trade_input"/></td>
                               
                            </tr>
                            <tr>
                                <td>PassingYear</td>
                                <td><input placeholder='Passing Year' type="text"value={GotTechPassingYear} onChange={GetTechPassingYear} className="tech_year_input"/></td>
                           
                            </tr>
                            <tr>
                                <td>%AGE</td>
                                <td><input placeholder='%Age' type="text" value={GotTechPercentagetech} onChange={GetTechPercentage} className="tech_percentag_input"/></td>
                               
                            </tr>
                            <tr>
                                
                                <td>Collage/ Univercity</td>

                                <td><input type="text"value={GotTechFromWhere} onChange={GetTechFromWhere}  className="tech_from_course_input" placeholder='Univercity Name'/></td>
                            </tr>
                        </thead>
                    </table>
                    <div className='submit_cont'>
                        <input type='submit' value='submit'/>
                
                    </div>
                </div>
                
            </fieldset>
        </form>


        <div id='ExperienceId' className='experience_main_div'>
            <fieldset className='main_fieldset_exp'>
                <legend>Work Experience</legend>
                <input type='checkbox' className='checkbox' onChange={checkboxclickhandlerwork}/>
                <form onSubmit={ExpFormSubmitHandler} className='exp_form_cont'>
                    <table>
                        <thead>
                            <tr>
                                <td>Worked Years</td>
                                <td>
                                <input className='experience_inputs' value={GotworkedYearwork} onChange={EnteredworkedExperience} type='number' placeholder='Enter Worked Year'/>
                                </td>
                            </tr>
                            <tr>
                                <td>Working As</td>
                                <td>
                                <input className='experience_inputs'  value={GotCompanyName} type='text' onChange={EnteredCompanyName} placeholder='Working As'/>
                                </td>
                            </tr>
                            <tr>
                                <td>ComnyName/ Address</td>
                                <td>
                                <input className='experience_inputs'  value={GotCompanyAddress} type='text'onChange={EnteredCompanyAddress} placeholder='Company Name & Address'/>
                                </td>
                            </tr>
                            <tr>
                                <td>Period</td>
                                <td>
                                <input className='experience_inputs'  value={GotCompanyDatetodate} type='text'onChange={EnteredCompanyDateToDate} placeholder='From Date To Date'/>
                                </td>
                            </tr>
                        </thead>
                    </table>
                    <div className='btn_cont_exp'>
                        <input type='submit' value='submit'/>
                    </div>
                </form>
            </fieldset>
        </div>
            
                
                
                <div className='fillformsubmitbtncont'>
                <button className='Submit_form' onClick={funalnext}>Next</button>
                </div>
            
            </div>   
            {/* <Link to="/CheckDetails">Next</Link> */}

             {/* Check details---------------------------------------------------------- */}

             <div className='hidecheckdetailscomp'>
            <div className='main_container'>
            <h3 className='resume_heading'>Check Resume Details</h3>
            <table className='Table_first perinfo'>
                <caption className='table1_caption'>Personal Details</caption>
                <tbody>
                    
                    <tr>
                        <td>Name</td>
                        <td>{dataforcheckdet.Name}</td>
                    </tr> 
                    <tr>
                        <td>Father's Name</td>
                        <td>{dataforcheckdet.fname}</td>
                    </tr>
                    <tr>
                        <td>Mother Name</td>
                        <td>{ dataforcheckdet.Mname}</td>
                    </tr>
                    <tr>
                        <td>Nationality</td>
                        <td>{dataforcheckdet.Nationality}</td>
                    </tr>
                    <tr>
                        <td>Hobbies</td>
                        <td>{dataforcheckdet.Hobbies}</td>
                    </tr>
                    <tr>
                        <td>Languages</td>
                        <td>{dataforcheckdet.Languages}</td>
                    </tr>
                    <tr> 
                        <td>Marrital Status</td>
                        <td>{dataforcheckdet.Marital_Status}</td>
                    </tr>
                    <tr>
                        <td>Religion</td>
                        <td>{dataforcheckdet.Religion}</td>
                    </tr>
                    <tr>
                        <td>Date Of Birth</td>
                        <td>{dataforcheckdet.dob}</td>
                    </tr>
                </tbody>
            </table>
            <table className='Table_first'>
                <caption className='table1_caption'>Address Details</caption>
                <tbody>
                    
                <tr>
                        <td>House No</td>
                        <td>{  dataforcheckdet.hnum }</td>
                    </tr>
                    <tr>
                        <td>Village</td>
                        <td>{ dataforcheckdet. Village}</td>
                    </tr>
                    <tr> 
                        <td>Post Office</td>          
                        <td>{dataforcheckdet.Post_Office}</td>
                    </tr> 
                    <tr>
                        <td>Police Station</td>
                        <td>{ dataforcheckdet. Thana}</td> 
                    </tr>
                    <tr>
                        <td>City</td>
                        <td>{ dataforcheckdet.District}</td>
                    </tr>
                    <tr>
                        <td>State</td>
                        <td>{dataforcheckdet.State}</td>
                    </tr>
                    <tr>
                        <td>Pin Code</td>
                        <td>{dataforcheckdet.Pin_Code}</td>
                    </tr>
                  
                </tbody>
            </table>
            <table className='Table_first'>
                <caption className='table1_caption'>Contact Details</caption>
                <tbody>
                    
                <tr>
                        <td>Mobile Number</td>
                        <td>{ dataforcheckdet.mobnum}</td>
                    </tr>
                    <tr>
                        <td>Email ID</td>
                        <td>{ dataforcheckdet.Email_ID}</td>
                    </tr>
                    <tr>
                        <td>Alternat number</td>
                        <td>{ dataforcheckdet.Alternate}</td>
                        
                    </tr>
                   
                  
                </tbody>
            </table>
            <table className='Table_academic academind'>
            <caption className='table1_caption'>Academic Qualification</caption>
                <thead>
                    <tr>    
                        <td>Stream</td>
                        <td>Board/Univercity</td>   
                        <td>Passing Year</td>
                        <td>%Age</td>
                    </tr>
                </thead>
                <tbody>
                    {
                        
                        Academicddata.map(
                            acaddata => (
                                
                            <tr>
                                <td>{acaddata.ExamName}</td>
                                <td>{acaddata.BoardName}</td>
                                <td>{acaddata.PassingYear}</td>
                                <td>{acaddata.PercentAge}</td>
                            </tr>
                        )
                    )
                    }
                </tbody>
                </table>
            
                <table className='Table_first computertablecont'>
                    <caption  className='table1_caption'>Computer Qualification</caption>
                    <thead>
                    <tr>
                            <td>Computer Course</td>
                            <td>Board/Univercity</td>
                            <td>Passing Year</td>
                            <td>%Age</td>
                        </tr>
                    </thead>
                    <tbody>
                        
                        {
                            
                            Comddata.map(
                                CompData => (
                                    <tr>
                                        <td className="samestyling_td">{CompData.CourseName}</td>
                                        <td className="samestyling_td">{CompData.Frompass}</td>
                                        <td className="samestyling_td">{CompData.Compassingy}</td>
                                        <td className="samestyling_td">{CompData.compercent}</td>
                                    </tr>
                            
                                )
                            )
                        }
                        
                    
                    </tbody>
                    </table>
                    <table className='Table_first techincaltablecont'>
                        <caption className='table1_caption'>Technical Qualification</caption>
                        <thead>
                        <tr>
                                <td>Stream</td>
                                <td>Board/Univercity</td>
                                <td>Passing Year</td>
                                <td>%Age</td>
                        </tr>
                        </thead>
                        
                        {
                             Techdata.map(
                                TechData => (
                                   

                                    <tbody>
                                        <tr className='sub_tr1'>
                                            <td className='samestyling_td'>{TechData.TechCourseName}</td>  
                                            <td className='samestyling_td'>{TechData.TechTradeName}</td>
                                            <td className='samestyling_td'>{TechData.TechPassingYear}</td>
                                            <td className='samestyling_td'>{TechData.TechPercentage}</td>
                            
                                        
                                        </tr>
                                        <tr className='sub_tr2'>
                                                <td colSpan='4' className='xxx'>  {TechData.Techfromwhere}</td>
                                            </tr>
                                    </tbody>
                                    
                                

                                )
                            )
                        } 
                    </table>
                    <div className='Exp_cont_in_checkdetails'>
                        <h3 className='exp_heading'>Word Experience</h3>
                        <ul>
                            {
                                Workexp.map(
                                    ExpdataToExpComp =>(  
                                    <li className='loop_li_of_exp'>  
                                        <span>{ExpdataToExpComp.ExperianceYear} </span>
                                        {ExpdataToExpComp.Year} 
                                        <span> {ExpdataToExpComp.CompanyName} </span> 
                                        {ExpdataToExpComp.At} 
                                        <span> {ExpdataToExpComp.CompanyAddress} </span> 
                                        {ExpdataToExpComp.From} 
                                        <span> {ExpdataToExpComp.FromDateToDate } </span>
                                    </li>
                                    )
                                )
                            }
                                    
                                    
                        </ul>
                    </div>
                    
            <div className='carrierdata_cont'>
                <h4 className='carrier_heading'>Carrier Objective</h4>
                <p>{carrierobj}</p>

            </div> 
            
            <div className='btn_cont'>
                <button className='btn' onClick={Finalsubmitfun}><Link to='../ChooseYourDesign'>Final Submit</Link></button>

            </div>  
            
        </div>
            
        </div>
        </div>
    );
}
 
export default AllComponentsContainer;